import { render, staticRenderFns } from "./KpiRequestTakenPerAlert.vue?vue&type=template&id=bf8e759e&"
import script from "./KpiRequestTakenPerAlert.vue?vue&type=script&lang=js&"
export * from "./KpiRequestTakenPerAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports